var map = {
	"../pages/acceptedlist/acceptedlist.module": [
		318,
		45
	],
	"../pages/accepteduserlist/accepteduserlist.module": [
		319,
		44
	],
	"../pages/accounting/accounting.module": [
		320,
		43
	],
	"../pages/addacceptedrecord/addacceptedrecord.module": [
		321,
		42
	],
	"../pages/addacceptuser/addacceptuser.module": [
		322,
		41
	],
	"../pages/addadmin/addadmin.module": [
		323,
		40
	],
	"../pages/addcaserecord/addcaserecord.module": [
		324,
		39
	],
	"../pages/addcovidrecord/addcovidrecord.module": [
		325,
		38
	],
	"../pages/addcriminalrecord/addcriminalrecord.module": [
		326,
		37
	],
	"../pages/addcurrentsurplus/addcurrentsurplus.module": [
		327,
		36
	],
	"../pages/adddonatedrecord/adddonatedrecord.module": [
		329,
		35
	],
	"../pages/adddonorrecord/adddonorrecord.module": [
		328,
		34
	],
	"../pages/addnofitication/addnofitication.module": [
		330,
		33
	],
	"../pages/addofficename/addofficename.module": [
		332,
		32
	],
	"../pages/addorganization/addorganization.module": [
		331,
		31
	],
	"../pages/addsoldier/addsoldier.module": [
		333,
		30
	],
	"../pages/addtownship/addtownship.module": [
		335,
		29
	],
	"../pages/caserecord/caserecord.module": [
		334,
		28
	],
	"../pages/cdmregister/cdmregister.module": [
		336,
		27
	],
	"../pages/covidrecord/covidrecord.module": [
		337,
		26
	],
	"../pages/criminalrecord/criminalrecord.module": [
		338,
		25
	],
	"../pages/currentsurplus/currentsurplus.module": [
		339,
		24
	],
	"../pages/details-caserecord/details-caserecord.module": [
		340,
		23
	],
	"../pages/details-criminalrecord/details-criminalrecord.module": [
		341,
		22
	],
	"../pages/details-soldier/details-soldier.module": [
		342,
		21
	],
	"../pages/donatedlist/donatedlist.module": [
		343,
		2
	],
	"../pages/donorlist/donorlist.module": [
		345,
		1
	],
	"../pages/feedback/feedback.module": [
		344,
		20
	],
	"../pages/forgotpassword/forgotpassword.module": [
		346,
		19
	],
	"../pages/home/home.module": [
		348,
		47
	],
	"../pages/importdonar/importdonar.module": [
		347,
		0
	],
	"../pages/intro/intro.module": [
		349,
		18
	],
	"../pages/login/login.module": [
		350,
		17
	],
	"../pages/manageadmin/manageadmin.module": [
		351,
		16
	],
	"../pages/multi-image/multi-image.module": [
		352,
		15
	],
	"../pages/notidetails/notidetails.module": [
		353,
		46
	],
	"../pages/notifications/notifications.module": [
		354,
		14
	],
	"../pages/orgsaccounting/orgsaccounting.module": [
		355,
		13
	],
	"../pages/passwordset/passwordset.module": [
		356,
		12
	],
	"../pages/profile-edit/profile-edit.module": [
		357,
		11
	],
	"../pages/profile/profile.module": [
		358,
		10
	],
	"../pages/register/register.module": [
		359,
		9
	],
	"../pages/soldiermanagement/soldiermanagement.module": [
		360,
		8
	],
	"../pages/uploadImage/uploadImage.module": [
		361,
		3
	],
	"../pages/version/version.module": [
		362,
		7
	],
	"../pages/viewcovidregion/viewcovidregion.module": [
		363,
		6
	],
	"../pages/viewdonatedrecord/viewdonatedrecord.module": [
		364,
		5
	],
	"../pages/viewdonorrecord/viewdonorrecord.module": [
		365,
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 164;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 164
// module chunks = 48